import { Modal } from "antd";
import SelectAreaComum from "components/Input/SelectAreaComum";
import { Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import FooterModal from "ui/components/Button/FooterModal";

interface ModalVincularAreaComumProps {
  isOpen: boolean;
  onClose: () => any;
  onSubmit: (id: string) => any;
  isLoading?: boolean;
  filterIds?: string[];
}

function ModalVincularAreaComum({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  filterIds,
}: ModalVincularAreaComumProps) {
  const [areaComumId, setAreaComumId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!isOpen) {
      setAreaComumId(undefined);
    }
  }, [isOpen]);

  return (
    <Modal
      width="400px"
      centered
      visible={isOpen}
      onCancel={onClose}
      title="Vincular área comum"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={() => {
            if (areaComumId) {
              onSubmit(areaComumId);
            }
          }}
          onClose={onClose}
          isLoadingSave={isLoading}
          isDisabled={isLoading || !areaComumId}
          showRegisterAnother={false}
          primaryButtonText="Vincular"
        />
      }
    >
      <Box>
        <SelectAreaComum
          value={areaComumId}
          onChange={setAreaComumId}
          placeholder="Selecione a área comum"
          filterIds={filterIds}
        />
      </Box>
    </Modal>
  );
}

export default ModalVincularAreaComum;
